// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.BulkSharing-module_root___xkJO0 {
  width: 1100px;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
}

.BulkSharing-module_top___PQVfu {
  display: flex;
  padding: 2rem 0;
  overflow: auto;
}
@media (max-width: 900px) {
  .BulkSharing-module_top___PQVfu {
    flex-direction: column;
  }
}

.theme--light .BulkSharing-module_left___a7nVW {
  border-right: 1px solid #dddddd;
  flex: 1;
  min-width: 200px;
  padding: 0 2rem;
  padding-top: 2rem;
  user-select: none;
}
.theme--dark .BulkSharing-module_left___a7nVW {
  border-right: 1px solid #2f2f2f;
  flex: 1;
  min-width: 200px;
  padding: 0 2rem;
  padding-top: 2rem;
  user-select: none;
}

.BulkSharing-module_mb___nbZNM {
  margin-bottom: 16px;
}

.BulkSharing-module_listingRulesContainer___xiFyd {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.BulkSharing-module_dropdown___KtbxJ {
  width: 50%;
  min-width: 100px;
  max-width: 100%;
}

.theme--light .BulkSharing-module_divider___EdzW1 {
  background-color: #dddddd;
  width: 1px;
}
.theme--dark .BulkSharing-module_divider___EdzW1 {
  background-color: #2f2f2f;
  width: 1px;
}

.BulkSharing-module_right___k3Gfs {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 420px;
  padding: 0 2rem;
  padding-top: 2rem;
}

.theme--light .BulkSharing-module_searchContainer___EbsFL {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  display: flex;
  font-size: 1.2rem;
  margin-bottom: 16px;
  overflow: hidden;
}
.theme--dark .BulkSharing-module_searchContainer___EbsFL {
  background-color: #000000;
  border: 1px solid #2f2f2f;
  border-radius: 4px;
  display: flex;
  font-size: 1.2rem;
  margin-bottom: 16px;
  overflow: hidden;
}
.theme--light .BulkSharing-module_searchContainer___EbsFL:focus-within {
  outline: 1px solid #212121;
}
.theme--dark .BulkSharing-module_searchContainer___EbsFL:focus-within {
  outline: 1px solid #f0f0f0;
}
.theme--light .BulkSharing-module_searchContainer___EbsFL input {
  color: #212121;
  background-color: #ffffff;
  padding: 1.2rem;
  border: none;
  outline: none;
  padding-left: 0.6rem;
  flex-grow: 1;
  min-width: 0;
  text-overflow: ellipsis;
}
.theme--dark .BulkSharing-module_searchContainer___EbsFL input {
  color: #f0f0f0;
  background-color: #000000;
  padding: 1.2rem;
  border: none;
  outline: none;
  padding-left: 0.6rem;
  flex-grow: 1;
  min-width: 0;
  text-overflow: ellipsis;
}

.BulkSharing-module_iconContainer___Pauxm {
  padding: 1.2rem;
  padding-right: 0.6rem;
}

.BulkSharing-module_marketplacesContainer___CJT5V {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(170px, 100%), 1fr));
  gap: 8px;
}

.theme--light .BulkSharing-module_singleMarketplace___fEWsX {
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 1.2rem;
  display: flex;
  gap: 6px;
  cursor: pointer;
  font-size: 1.2rem;
}
.theme--dark .BulkSharing-module_singleMarketplace___fEWsX {
  border: 1px solid #2f2f2f;
  border-radius: 4px;
  padding: 1.2rem;
  display: flex;
  gap: 6px;
  cursor: pointer;
  font-size: 1.2rem;
}

.BulkSharing-module_imageContainer___RO6m3 {
  flex-shrink: 0;
  width: 16px;
  aspect-ratio: 1/1;
}
.BulkSharing-module_imageContainer___RO6m3 img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  display: block;
}

.BulkSharing-module_marketplaceName___viUVr {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.BulkSharing-module_singleMarketplace___fEWsX[data-selected=true] {
  border-color: var(--textDetails);
}

.BulkSharing-module_singleMarketplace___fEWsX[data-disabled=true] {
  opacity: 0.4;
}

.theme--light .BulkSharing-module_subHeader___u3GSB {
  color: #212121;
  font-size: 1.6rem;
  font-weight: 600;
}
.theme--dark .BulkSharing-module_subHeader___u3GSB {
  color: #f0f0f0;
  font-size: 1.6rem;
  font-weight: 600;
}

.theme--light .BulkSharing-module_subHeaderSecondary___Wzv0J {
  color: #888888;
  font-size: 1.4rem;
}
.theme--dark .BulkSharing-module_subHeaderSecondary___Wzv0J {
  color: #a3a3a3;
  font-size: 1.4rem;
}

.BulkSharing-module_broadcastHeader___t5VSm {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 16px;
  gap: 6px;
}

.BulkSharing-module_shareSelect___z6Mzw {
  color: var(--textDetails);
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 500;
  flex-shrink: 0;
}

.BulkSharing-module_shareSelect___z6Mzw:hover {
  text-decoration: underline;
}

.theme--light .BulkSharing-module_rightTopHeaders___EKaaZ {
  border-bottom: 1px solid #dddddd;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 1.6rem;
}
.theme--dark .BulkSharing-module_rightTopHeaders___EKaaZ {
  border-bottom: 1px solid #2f2f2f;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 1.6rem;
}

.theme--light .BulkSharing-module_warning___pPo4j {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  margin-top: 1.6rem;
  border-radius: 6px;
}
.theme--dark .BulkSharing-module_warning___pPo4j {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  margin-top: 1.6rem;
  border-radius: 6px;
}

.BulkSharing-module_warningHeader___ckr0P {
  font-size: 1.4rem;
  font-weight: 600;
}

.BulkSharing-module_textSecondary___Qpexi {
  font-size: 1.2rem;
  font-weight: 400;
}

.theme--light .BulkSharing-module_buttons___JqnXE {
  border-top: 1px solid #dddddd;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 2rem;
}
.theme--dark .BulkSharing-module_buttons___JqnXE {
  border-top: 1px solid #2f2f2f;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 2rem;
}

.BulkSharing-module_listings___Trds0 {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  overflow: auto;
}

.theme--light .BulkSharing-module_singleListing____hWdN {
  border-top: 1px solid #dddddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  padding: 6px;
  font-size: 1.4rem;
}
.theme--dark .BulkSharing-module_singleListing____hWdN {
  border-top: 1px solid #2f2f2f;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  padding: 6px;
  font-size: 1.4rem;
}

.BulkSharing-module_singleListing____hWdN[data-no-border=true] {
  border: none;
}

.theme--light .BulkSharing-module_xContainer___Jpj4r {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 30px;
  align-self: stretch;
  align-items: start;
}
.theme--dark .BulkSharing-module_xContainer___Jpj4r {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 30px;
  align-self: stretch;
  align-items: start;
}
.theme--light .BulkSharing-module_xContainer___Jpj4r div {
  display: flex;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border-radius: 6px;
  background: #dddddd;
  transition: 200ms;
}
.theme--dark .BulkSharing-module_xContainer___Jpj4r div {
  display: flex;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border-radius: 6px;
  background: #2f2f2f;
  transition: 200ms;
}
.theme--light .BulkSharing-module_xContainer___Jpj4r div:hover {
  padding: 2px;
  background: #888888;
}
.theme--dark .BulkSharing-module_xContainer___Jpj4r div:hover {
  padding: 2px;
  background: #a3a3a3;
}

.BulkSharing-module_itemTextPrimary___PM1g_ {
  font-size: 1.4rem;
  font-weight: 500;
}

.theme--light .BulkSharing-module_fakeItem___WCmZd {
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 1.2rem;
  display: flex;
  gap: 6px;
  cursor: pointer;
  font-size: 1.2rem;
  height: 42px;
}
.theme--dark .BulkSharing-module_fakeItem___WCmZd {
  border: 1px solid #2f2f2f;
  border-radius: 4px;
  padding: 1.2rem;
  display: flex;
  gap: 6px;
  cursor: pointer;
  font-size: 1.2rem;
  height: 42px;
}

.BulkSharing-module_secRowSeat___Sru7e {
  flex-grow: 1;
  min-width: 20px;
}

.theme--light .BulkSharing-module_qty___wM8B1 {
  color: #888888;
  width: 45px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkSharing-module_qty___wM8B1 {
  color: #a3a3a3;
  width: 45px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.theme--light .BulkSharing-module_splitLabel___ymuqn {
  color: #888888;
  width: 60px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkSharing-module_splitLabel___ymuqn {
  color: #a3a3a3;
  width: 60px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.theme--light .BulkSharing-module_priceLabel___qFwn2 {
  color: #888888;
  width: 90px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkSharing-module_priceLabel___qFwn2 {
  color: #a3a3a3;
  width: 90px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.BulkSharing-module_secRowSeatCont___jpoI4 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/bulkSharing/BulkSharing.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAmBD;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,cAAA;AAmBD;AAjBC;EALD;IAME,sBAAA;EAoBA;AACF;;ADmEE;EClFA,+BAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAmBF;AD0DE;EClFA,+BAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AA2BF;;AAvBA;EACC,mBAAA;AA0BD;;AAvBA;EACC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AA0BD;;AAvBA;EACC,UAAA;EACA,gBAAA;EACA,eAAA;AA0BD;;ADiCE;ECtDA,yBAAA;EACA,UAAA;AAyBF;AD4BE;ECtDA,yBAAA;EACA,UAAA;AA6BF;;AAzBA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA4BD;;ADcE;ECrCA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA2BF;ADIE;ECrCA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAoCF;ADLE;EC1BC,0BAAA;AAkCH;ADRE;EC1BC,0BAAA;AAqCH;ADXE;ECpBC,cAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AAkCH;ADtBE;ECpBC,cAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AA6CH;;AAxCA;EACC,eAAA;EACA,qBAAA;AA2CD;;AAxCA;EACC,aAAA;EACA,uEAAA;EACA,QAAA;AA2CD;;AD5CE;ECMA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;AA0CF;ADtDE;ECMA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;AAmDF;;AA/CA;EACC,cAAA;EACA,WAAA;EACA,iBAAA;AAkDD;AAhDC;EACC,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAkDF;;AA9CA;EACC,gBAAA;EACA,uBAAA;EACA,mBAAA;AAiDD;;AA9CA;EACC,gCAAA;AAiDD;;AA9CA;EACC,YAAA;AAiDD;;ADzFE;EC6CA,cAAA;EACA,iBAAA;EACA,gBAAA;AAgDF;AD/FE;EC6CA,cAAA;EACA,iBAAA;EACA,gBAAA;AAqDF;;ADpGE;ECqDA,cAAA;EACA,iBAAA;AAmDF;ADzGE;ECqDA,cAAA;EACA,iBAAA;AAuDF;;AAnDA;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAsDD;;AAnDA;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAsDD;;AAnDA;EACC,0BAAA;AAsDD;;ADjIE;ECgFA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AAqDF;ADzIE;ECgFA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AA4DF;;ADhJE;EC0FA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AA0DF;ADzJE;EC0FA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAkEF;;AA9DA;EACC,iBAAA;EACA,gBAAA;AAiED;;AA9DA;EACC,iBAAA;EACA,gBAAA;AAiED;;AD3KE;EC+GA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAgEF;ADnLE;EC+GA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAuEF;;AAnEA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAsED;;ADjME;ECgIA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAqEF;AD3ME;ECgIA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AA8EF;;AA1EA;EACC,YAAA;AA6ED;;ADxNE;ECgJA,aAAA;EACA,yBAAA;EACA,mBAAA;EAEA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA2EF;ADlOE;ECgJA,aAAA;EACA,yBAAA;EACA,mBAAA;EAEA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAoFF;AD3OE;EC4JC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAkFH;ADpPE;EC4JC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AA2FH;AD7PE;ECwKC,YAAA;EACA,mBAAA;AAwFH;ADjQE;ECwKC,YAAA;EACA,mBAAA;AA4FH;;AAvFA;EACC,iBAAA;EACA,gBAAA;AA0FD;;AD1QE;ECqLA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAyFF;ADrRE;ECqLA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAmGF;;AA/FA;EACC,YAAA;EACA,eAAA;AAkGD;;ADpSE;ECuMA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAiGF;AD3SE;ECuMA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAuGF;;ADjTE;ECgNA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAqGF;ADxTE;ECgNA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA2GF;;AD9TE;ECyNA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAyGF;ADrUE;ECyNA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA+GF;;AA3GA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AA8GD","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.root {\n  width: 1100px;\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.top {\n  display: flex;\n  padding: 2rem 0;\n  overflow: auto;\n}\n@media (max-width: 900px) {\n  .top {\n    flex-direction: column;\n  }\n}\n\n:global(.theme--light) .left {\n  border-right: 1px solid #dddddd;\n  flex: 1;\n  min-width: 200px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n  user-select: none;\n}\n:global(.theme--dark) .left {\n  border-right: 1px solid #2f2f2f;\n  flex: 1;\n  min-width: 200px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n  user-select: none;\n}\n\n.mb {\n  margin-bottom: 16px;\n}\n\n.listingRulesContainer {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.dropdown {\n  width: 50%;\n  min-width: 100px;\n  max-width: 100%;\n}\n\n:global(.theme--light) .divider {\n  background-color: #dddddd;\n  width: 1px;\n}\n:global(.theme--dark) .divider {\n  background-color: #2f2f2f;\n  width: 1px;\n}\n\n.right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 420px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n}\n\n:global(.theme--light) .searchContainer {\n  background-color: #ffffff;\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  display: flex;\n  font-size: 1.2rem;\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n:global(.theme--dark) .searchContainer {\n  background-color: #000000;\n  border: 1px solid #2f2f2f;\n  border-radius: 4px;\n  display: flex;\n  font-size: 1.2rem;\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n:global(.theme--light) .searchContainer:focus-within {\n  outline: 1px solid #212121;\n}\n:global(.theme--dark) .searchContainer:focus-within {\n  outline: 1px solid #f0f0f0;\n}\n:global(.theme--light) .searchContainer input {\n  color: #212121;\n  background-color: #ffffff;\n  padding: 1.2rem;\n  border: none;\n  outline: none;\n  padding-left: 0.6rem;\n  flex-grow: 1;\n  min-width: 0;\n  text-overflow: ellipsis;\n}\n:global(.theme--dark) .searchContainer input {\n  color: #f0f0f0;\n  background-color: #000000;\n  padding: 1.2rem;\n  border: none;\n  outline: none;\n  padding-left: 0.6rem;\n  flex-grow: 1;\n  min-width: 0;\n  text-overflow: ellipsis;\n}\n\n.iconContainer {\n  padding: 1.2rem;\n  padding-right: 0.6rem;\n}\n\n.marketplacesContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(170px, 100%), 1fr));\n  gap: 8px;\n}\n\n:global(.theme--light) .singleMarketplace {\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  padding: 1.2rem;\n  display: flex;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 1.2rem;\n}\n:global(.theme--dark) .singleMarketplace {\n  border: 1px solid #2f2f2f;\n  border-radius: 4px;\n  padding: 1.2rem;\n  display: flex;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 1.2rem;\n}\n\n.imageContainer {\n  flex-shrink: 0;\n  width: 16px;\n  aspect-ratio: 1/1;\n}\n.imageContainer img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.marketplaceName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.singleMarketplace[data-selected=true] {\n  border-color: var(--textDetails);\n}\n\n.singleMarketplace[data-disabled=true] {\n  opacity: 0.4;\n}\n\n:global(.theme--light) .subHeader {\n  color: #212121;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n:global(.theme--dark) .subHeader {\n  color: #f0f0f0;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n:global(.theme--light) .subHeaderSecondary {\n  color: #888888;\n  font-size: 1.4rem;\n}\n:global(.theme--dark) .subHeaderSecondary {\n  color: #a3a3a3;\n  font-size: 1.4rem;\n}\n\n.broadcastHeader {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  gap: 6px;\n}\n\n.shareSelect {\n  color: var(--textDetails);\n  cursor: pointer;\n  font-size: 1.4rem;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.shareSelect:hover {\n  text-decoration: underline;\n}\n\n:global(.theme--light) .rightTopHeaders {\n  border-bottom: 1px solid #dddddd;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 1.6rem;\n}\n:global(.theme--dark) .rightTopHeaders {\n  border-bottom: 1px solid #2f2f2f;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 1.6rem;\n}\n\n:global(.theme--light) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  margin-top: 1.6rem;\n  border-radius: 6px;\n}\n:global(.theme--dark) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  margin-top: 1.6rem;\n  border-radius: 6px;\n}\n\n.warningHeader {\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.textSecondary {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n:global(.theme--light) .buttons {\n  border-top: 1px solid #dddddd;\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n:global(.theme--dark) .buttons {\n  border-top: 1px solid #2f2f2f;\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n\n.listings {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  overflow: auto;\n}\n\n:global(.theme--light) .singleListing {\n  border-top: 1px solid #dddddd;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 1.4rem;\n}\n:global(.theme--dark) .singleListing {\n  border-top: 1px solid #2f2f2f;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 1.4rem;\n}\n\n.singleListing[data-no-border=true] {\n  border: none;\n}\n\n:global(.theme--light) .xContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  width: 30px;\n  align-self: stretch;\n  align-items: start;\n}\n:global(.theme--dark) .xContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  width: 30px;\n  align-self: stretch;\n  align-items: start;\n}\n:global(.theme--light) .xContainer div {\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  justify-content: center;\n  border-radius: 6px;\n  background: #dddddd;\n  transition: 200ms;\n}\n:global(.theme--dark) .xContainer div {\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  justify-content: center;\n  border-radius: 6px;\n  background: #2f2f2f;\n  transition: 200ms;\n}\n:global(.theme--light) .xContainer div:hover {\n  padding: 2px;\n  background: #888888;\n}\n:global(.theme--dark) .xContainer div:hover {\n  padding: 2px;\n  background: #a3a3a3;\n}\n\n.itemTextPrimary {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n:global(.theme--light) .fakeItem {\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  padding: 1.2rem;\n  display: flex;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 1.2rem;\n  height: 42px;\n}\n:global(.theme--dark) .fakeItem {\n  border: 1px solid #2f2f2f;\n  border-radius: 4px;\n  padding: 1.2rem;\n  display: flex;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 1.2rem;\n  height: 42px;\n}\n\n.secRowSeat {\n  flex-grow: 1;\n  min-width: 20px;\n}\n\n:global(.theme--light) .qty {\n  color: #888888;\n  width: 45px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .qty {\n  color: #a3a3a3;\n  width: 45px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n:global(.theme--light) .splitLabel {\n  color: #888888;\n  width: 60px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .splitLabel {\n  color: #a3a3a3;\n  width: 60px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n:global(.theme--light) .priceLabel {\n  color: #888888;\n  width: 90px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .priceLabel {\n  color: #a3a3a3;\n  width: 90px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n.secRowSeatCont {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BulkSharing-module_root___xkJO0`,
	"top": `BulkSharing-module_top___PQVfu`,
	"left": `BulkSharing-module_left___a7nVW`,
	"mb": `BulkSharing-module_mb___nbZNM`,
	"listingRulesContainer": `BulkSharing-module_listingRulesContainer___xiFyd`,
	"dropdown": `BulkSharing-module_dropdown___KtbxJ`,
	"divider": `BulkSharing-module_divider___EdzW1`,
	"right": `BulkSharing-module_right___k3Gfs`,
	"searchContainer": `BulkSharing-module_searchContainer___EbsFL`,
	"iconContainer": `BulkSharing-module_iconContainer___Pauxm`,
	"marketplacesContainer": `BulkSharing-module_marketplacesContainer___CJT5V`,
	"singleMarketplace": `BulkSharing-module_singleMarketplace___fEWsX`,
	"imageContainer": `BulkSharing-module_imageContainer___RO6m3`,
	"marketplaceName": `BulkSharing-module_marketplaceName___viUVr`,
	"subHeader": `BulkSharing-module_subHeader___u3GSB`,
	"subHeaderSecondary": `BulkSharing-module_subHeaderSecondary___Wzv0J`,
	"broadcastHeader": `BulkSharing-module_broadcastHeader___t5VSm`,
	"shareSelect": `BulkSharing-module_shareSelect___z6Mzw`,
	"rightTopHeaders": `BulkSharing-module_rightTopHeaders___EKaaZ`,
	"warning": `BulkSharing-module_warning___pPo4j`,
	"warningHeader": `BulkSharing-module_warningHeader___ckr0P`,
	"textSecondary": `BulkSharing-module_textSecondary___Qpexi`,
	"buttons": `BulkSharing-module_buttons___JqnXE`,
	"listings": `BulkSharing-module_listings___Trds0`,
	"singleListing": `BulkSharing-module_singleListing____hWdN`,
	"xContainer": `BulkSharing-module_xContainer___Jpj4r`,
	"itemTextPrimary": `BulkSharing-module_itemTextPrimary___PM1g_`,
	"fakeItem": `BulkSharing-module_fakeItem___WCmZd`,
	"secRowSeat": `BulkSharing-module_secRowSeat___Sru7e`,
	"qty": `BulkSharing-module_qty___wM8B1`,
	"splitLabel": `BulkSharing-module_splitLabel___ymuqn`,
	"priceLabel": `BulkSharing-module_priceLabel___qFwn2`,
	"secRowSeatCont": `BulkSharing-module_secRowSeatCont___jpoI4`
};
export default ___CSS_LOADER_EXPORT___;
